






import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';

@Component
export default class KeepBadge extends Vue {
  @Prop({ type: Number, required: true }) private value!: 0;
  get myValue() {
    return this.value > 99 ? '99+' : this.value;
  }
}
